import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const logradouroReducer = (state = InitialState.logradouroReducer, action) => {
    switch (action.type) {
        case ActionType.GET_LOGRADOURO_RESPONSE: {
            return {
                ...state,
                logradouroObject: _.assign(action.logradouroObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default logradouroReducer;